import useUserPermissions from "../../../../../../common/utils/user/permissions/use-user-permissions";
import passengerListingUserPermissionDefinition from "./passenger-listing-user-permission";

const usePassengerListingUserPermissions = () => {
  return useUserPermissions(passengerListingUserPermissionDefinition);
};

export default usePassengerListingUserPermissions;
